import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
// import { useAppSelector } from '../../reducers/rootReducer';
import Preloader from '../Preloader/Preloader';

export default function RoutesProtector() {
  // const { isLoggedIn } = useAppSelector((state) => state.userSession);
  const { isAuthenticated } = useAuth0();
  const location = useLocation();

  // // Skip protection for auth-redirect route
  // if (location.pathname === '/auth-redirect') {
  //   return <Outlet />;
  // }

  // Wait for Auth0 to finish loading before making authentication decisions

  // Allow access if authenticated
  if (isAuthenticated) {
    return (
      <Suspense fallback={<Preloader />}>
        <Outlet />
      </Suspense>
    );
  }
  localStorage.setItem('redirectUrl', location.pathname + location.search);
  // Redirect to home if not authenticated
  return <Preloader />;
}
